export enum InheritanceModes {
    Inherit = "inherit",
    Append = "append",
    Replace = "replace",
    Clear = "clear"
}